import React from 'react';
import { useTranslation } from 'react-i18next';
import Badge from '@material-ui/core/Badge';
import {
  makeStyles,
  createStyles,
} from '@material-ui/core/styles';
import { capitalizeFirstLetter } from '../../../helpers';

const useStyles = makeStyles(theme => createStyles({
  badge: isMobileApp
    ? {
      top: '0px !important',
      right: '-5px !important',
      fontSize: 0,
      height: 12,
      width: 10,
      minWidth: 'auto',
    }
    : {
      top: 12,
      right: -20,
    },
  badgeNew: {
    right: -26,
  },
}));

export default function MenuItemLabel({
  type,
  pupil,
  user,
}) {
  const classes = useStyles();
  const { t } = useTranslation(undefined, { useSuspense: false });

  if (type === 'behaviour') {
    return t('Behaviour');
  } else if (type === 'parent_behaviour') {
    return t('Award behaviour');
  } else if (type === 'report_cards') {
    return t('On-Report Cards');
  } else if (type === 'classes') {
    return t('Classes');
  } else if (type === 'timetable') {
    return t('Timetable');
  } else if (type === 'attendance') {
    return t('Attendance');
  } else if (type === 'rewards') {
    return t('Rewards');
  } else if (type === 'absences') {
    return t('Report absence');
  } else if (type === 'report_concern') {
    return t('Report concern');
  } else if (type === 'covid_tests') {
    return t('COVID Tests');
  } else if (type === 'event_badges') {
    return t('Badges');
  } else if (type === 'custom_fields') {
    return t('Pupil fields');
  } else if (type === 'change_avatar') {
    return t('Change avatar');
  } else if (type === 'academic_reports') {
    return t('Academic reports');
  } else if (type === 'announcements') {
    let text = t('Announcements');
    if (pupil?.announcements_count > 0) {
      text = (
        <Badge
          classes={{
            badge: classes.badge,
          }}
          badgeContent={pupil.announcements_count}
          color="secondary"
        >
          {t('Announcements')}
        </Badge>
      );
    }

    return text;
  } else if (type === 'homework') {
    let text = t('Homework');
    if (pupil?.homework_todo_count > 0) {
      text = (
        <Badge
          classes={{
            badge: classes.badge,
          }}
          badgeContent={pupil.homework_todo_count}
          color="secondary"
        >
          {t('Homework')}
        </Badge>
      );
    }
    return text;
  } else if (type === 'detentions') {
    let text = pupil.detention_alias_plural_uc;
    if (pupil?.detentions_pending_count > 0) {
      text = (
        <Badge
          classes={{
            badge: classes.badge,
          }}
          badgeContent={pupil.detentions_pending_count}
          color="secondary"
        >
          {pupil.detention_alias_plural_uc}
        </Badge>
      );
    }
    return text;
  } else if (type === 'messages') {
    let text = t('Messages');
    if (pupil?.messages_count > 0) {
      text = (
        <Badge
          classes={{
            badge: classes.badge,
          }}
          badgeContent={pupil.messages_count}
          color="secondary"
        >
          {t('Messages')}
        </Badge>
      );
    }
    return text;
  } else if (type === 'tracking') {
    let text = t('Wellbeing');
    if (user?.survey_id) {
      text = (
        <Badge
          classes={{
            badge: `${classes.badge} ${classes.badgeNew}`,
          }}
          badgeContent={t('New')}
          color="secondary"
        >
          {t('Wellbeing')}
        </Badge>
      );
    }
    return text;
  }

  return capitalizeFirstLetter(type);
}
